// extracted by mini-css-extract-plugin
module.exports = {"mobileNavigationWrapper":"styles_mobileNavigationWrapper__D4sDD","mobileNavigation":"styles_mobileNavigation__aATlK"};